<div class="technologies md:px-20 md:py-20 sl:px-4 sl:py-8">
    <div class="heading flex flex-col justify-between xl:gap-x-[80px] xl:flex-row sl:items-start xl:items-center">
        <h2 class="flex-1">
            <span class="highlight md:text-64 sl:text-36">Technologies</span><br />
            <span class="sub md:text-56 sl:text-32">tailored to your needs.</span>
        </h2>
        <p class="description flex-1 sl:mt-4 md:text-20 sl:text-14">We cover all the technology stacks needed to ensure high-quality results and on-time delivery for every project.</p>
    </div>
    <div class="tabs flex justify-between max-md:hidden">
        <button *ngFor="let tab of tabs" [class.active]="selectedTab === tab" (click)="selectTab(tab)">
            {{ tab }}
        </button>
    </div>
    <div class="mobile-tabs flex flex-row gap-2 mt-8 md:hidden overflow-x-auto">
        <button
            *ngFor="let tab of tabs"
            class="w-full text-center text-base font-medium rounded-[20px] transition whitespace-nowrap"
            [ngClass]="{
                'bg-gradient-to-r from-[#262AFF] to-[#1B1EC6] text-white border-transparent active': selectedTab === tab,
                'text-[#21272a] bg-[#f8f8f8]': selectedTab !== tab,
            }"
            (click)="selectTab(tab)"
        >
            {{ tab }}
        </button>
    </div>
    <div class="cards grid" *ngIf="technologies[selectedTab]">
        <div class="card" *ngFor="let tech of technologies[selectedTab]">
            <div class="header flex justify-between items-center">
                <span class="title">{{ tech.name }}</span>
                <img [src]="'assets/images/' + tech.icon + '.svg'" alt="{{ tech.name }} logo" />
            </div>
            <div class="description">{{ tech.description }}</div>
        </div>
    </div>
    <div class="flex justify-center gap-3 mt-6 md:hidden">
        <span
            *ngFor="let tab of tabs"
            class="w-3 h-3 rounded-full transition-colors duration-300 cursor-pointer"
            [ngClass]="{
                'bg-[#262aff]': selectedTab === tab,
                'bg-[#c4c4c4]': selectedTab !== tab,
            }"
            (click)="selectTab(tab)"
        >
        </span>
    </div>
</div>
